import { createStyles, makeStyles, Theme } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accountHeader: {
      padding: theme.spacing(6, 0, 2),
    },
    title: {
      paddingBottom: theme.spacing(2),
    },
  })
);
